import { combineReducers } from 'redux';
import { services } from './services';
import { reservations } from './reservation';


const appReducer = combineReducers({
  services,
  reservations,
});

const rootReducer = (state, action) => {
  if (action.type === 'INIT_LOG_OUT') {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer;